import { useAuth } from '../hooks/useAuth'

export default function Login() {
  const { signInWithGoogle } = useAuth()

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <div style={styles.logoMark}>G</div>
        <div style={styles.title}>Gallicantus</div>
        <div style={styles.subtitle}>Reporting Platform</div>
        <p style={styles.desc}>
          Accedi con il tuo account <strong>@gallicantus.it</strong> per continuare.
        </p>
        <button style={styles.btn} onClick={signInWithGoogle}>
          <svg width="18" height="18" viewBox="0 0 18 18" style={{marginRight: 10}}>
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"/>
            <path fill="#FBBC05" d="M3.964 10.707A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.039l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z"/>
          </svg>
          Accedi con Google
        </button>
        <p style={styles.hint}>Solo account @gallicantus.it sono autorizzati</p>
      </div>
    </div>
  )
}

const styles = {
  root: {
    minHeight: '100vh', background: '#0a0a0f',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Geist', sans-serif",
  },
  card: {
    background: '#111118', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16, padding: '48px 40px', textAlign: 'center',
    width: 360, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12,
  },
  logoMark: {
    width: 48, height: 48, background: '#6b5ce7', borderRadius: 12,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 22, fontWeight: 700, color: 'white', marginBottom: 4,
  },
  title: { fontSize: 22, fontWeight: 600, color: '#e8e8f0', fontFamily: 'DM Serif Display, serif' },
  subtitle: { fontSize: 12, color: '#55556a', fontFamily: 'DM Mono, monospace', letterSpacing: 1 },
  desc: { fontSize: 13, color: '#8888a8', lineHeight: 1.6, margin: '8px 0' },
  btn: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'white', color: '#1a1a2e', border: 'none',
    borderRadius: 8, padding: '11px 24px', fontSize: 14, fontWeight: 600,
    cursor: 'pointer', width: '100%', marginTop: 8, transition: 'opacity 0.15s',
  },
  hint: { fontSize: 11, color: '#55556a', marginTop: 4 },
}
